const DAY_MS = 86_400_000;

// API dates are midnight UTC, so format and compare them in UTC to avoid drift.
const utcDay = (iso: string) => {
  const d = new Date(iso);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
};

const todayUtcDay = () => {
  const n = new Date();
  return Date.UTC(n.getFullYear(), n.getMonth(), n.getDate());
};

export const formatDate = (iso: string) =>
  new Intl.DateTimeFormat("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(iso));

export const formatDateLong = (iso: string) =>
  new Intl.DateTimeFormat("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(iso));

export const formatWeekday = (iso: string) =>
  new Intl.DateTimeFormat("en-IN", { weekday: "long", timeZone: "UTC" }).format(
    new Date(iso),
  );

export const formatDateTime = (iso: string) =>
  new Intl.DateTimeFormat("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(iso));

export const titleCase = (s: string) =>
  s.toLowerCase().replace(/^\w/, (c) => c.toUpperCase());

const STATUS_STYLES: Record<string, string> = {
  PENDING: "border-amber-200 bg-amber-50 text-amber-800",
  APPROVED: "border-emerald-200 bg-emerald-50 text-emerald-800",
  REJECTED: "border-red-200 bg-red-50 text-red-800",
  WITHDRAWN: "border-slate-200 bg-slate-100 text-slate-700",
};

export const getStatusStyle = (status: string) =>
  STATUS_STYLES[status.toUpperCase()] ??
  "border-slate-200 bg-slate-100 text-slate-700";

/** Days from today to the last working day, plus notice-period progress (0 to 1). */
export const getNoticeProgress = (
  resignationDate: string,
  lastWorkingDay: string,
) => {
  const start = utcDay(resignationDate);
  const end = utcDay(lastWorkingDay);
  const now = todayUtcDay();

  const daysLeft = Math.round((end - now) / DAY_MS);
  const progress =
    end > start ? Math.min(1, Math.max(0, (now - start) / (end - start))) : 1;

  const label =
    daysLeft > 1
      ? `${daysLeft} days left`
      : daysLeft === 1
        ? "1 day left"
        : daysLeft === 0
          ? "Last day is today"
          : "Notice period completed";

  return { daysLeft, progress, label };
};

export const getInitials = (name: string) =>
  name
    .split(" ")
    .filter(Boolean)
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
